import { FeaturePages, IBubbleContent, ILegacyNotification } from '../models';
import { TeachingBubbleCategory } from './NotificationConstants';
import { categoryMap } from './CategoryMap';
import { getTenantId } from 'src/Common/Models/StoreConstants';
import { UATConstants } from 'src/Common/Models/UATConstants';

const TeachingBubbleSeparator = ':';

const checkAccess = (type: string, flights: string[]) => {
  const flightsToCheck = type.split(':')[1];
  if (flightsToCheck && flights) {
    return flights.includes(flightsToCheck);
  }
  return true;
};

/**
 * Transforms an array of legacy notifications into an array of bubble content objects.
 * @param notifications - The array of legacy notifications to transform.
 * @returns An array of bubble content objects.
 */
export const transformNotificationBubbles = (
  notifications: ILegacyNotification[],
  currentPage: FeaturePages,
  flights: string[],
  data?: any
): IBubbleContent[] => {
  // Don't show notifications for COMPETE tenant on Create and Manage page
  const currentTenantId = getTenantId();
  const tags = data?.Fields?.[UATConstants.UATFields.Tags] || '';
  const hasCompeteTag = tags.includes('Copilot Compete');
  const isCompeteAction =
    data?.Fields?.[UATConstants.UATFields.AreaPath] ===
      UATConstants.TechRoBAreaPaths.WCBABSTriage ||
    data?.Fields?.[UATConstants.UATFields.AreaPath] ===
      UATConstants.TechRoBAreaPaths.WCBCustomerSuccessABSScrum ||
    data?.Fields?.[UATConstants.UATFields.AreaPath] ===
      UATConstants.TechRoBAreaPaths.WCBMicrosoftSolutionsABSScrum;

  if (
    currentPage === 'CreateActionForField' &&
    (currentTenantId === UATConstants.TenantIds.COMPETE || (hasCompeteTag && isCompeteAction))
  ) {
    return [];
  }

  return notifications
    .filter((notification) =>
      notification.tag?.startsWith(`${TeachingBubbleCategory}:${currentPage}`)
    )
    .filter((notification) => checkAccess(notification.type, flights))
    .filter((notification) => notification.tag.split(TeachingBubbleSeparator)[2] in categoryMap)
    .map(({ tag, id, title, htmlMessage, referenceLink }) => {
      const currentCategory = tag.split(TeachingBubbleSeparator)[2];
      const { targetId, bubblePosition } = categoryMap[currentCategory];

      return {
        notificationId: id.toString(),
        targetId,
        headline: title,
        content: htmlMessage,
        bubblePosition,
        action: referenceLink,
      };
    });
};
